import { cn } from '@/lib/cn';
import { useState } from 'react';

interface SampleValuesCellProps {
  values: unknown[] | null;
}

const PREVIEW = 3;

function fmt(v: unknown): string {
  if (v === null || v === undefined) return 'null';
  if (typeof v === 'string') return v;
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
}

export function SampleValuesCell({ values }: SampleValuesCellProps) {
  const [expanded, setExpanded] = useState(false);
  if (!values || values.length === 0) {
    return <span className="text-foreground-muted">—</span>;
  }
  const visible = expanded ? values : values.slice(0, PREVIEW);
  const remaining = values.length - PREVIEW;
  return (
    <div className="flex flex-wrap gap-1 items-center">
      {visible.map((v, i) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: values 는 안정적 순서
          key={i}
          className="inline-block max-w-[160px] truncate rounded-sm px-1.5 h-5 leading-5 bg-surface-muted/60 font-mono text-[11px]"
          title={fmt(v)}
        >
          {fmt(v)}
        </span>
      ))}
      {!expanded && remaining > 0 ? (
        <button
          type="button"
          className={cn(
            'text-[11px] text-foreground-muted hover:text-foreground rounded-sm px-1 h-5',
          )}
          onClick={() => setExpanded(true)}
        >
          +{remaining}
        </button>
      ) : null}
    </div>
  );
}
